import { validate } from '@/utils/errors/helpers';
import { axios } from './axiosClient';
import type {
  ModuleInstallation,
  MWAccountGroup,
  MWApplication,
  MWCountry,
  MWModule,
  MWRouteTypes,
  MWUserType,
  ParamValue,
} from '@/types/MW';
import { getInstallationSchema } from '@/types/schemas/mw/getInstallation';
import { getMWAccountGroupsSchema } from '@/types/schemas/mw/getMWAccountGroups';
import { getMWModulesSchema } from '@/types/schemas/mw/getMWModules';
import { getMWApplicationsSchema } from '@/types/schemas/mw/getMWApplications';
import { getMWUserTypesSchema } from '@/types/schemas/mw/getMWUserTypes';
import type { DataType } from '@/types/MW';
import { getDataTypesSchema } from '@/types/schemas/mw/getDataTypes';
import { getMWRouteTypesSchema } from '@/types/schemas/mw/getMWRouteTypes';
import { getMWCountriesSchema } from '@/types/schemas/mw/getMWCountries';

export async function getMWAccountGroups(): Promise<MWAccountGroup[]> {
  const response = await axios.get('v2/mw/account-groups');
  return validate(getMWAccountGroupsSchema, response.data.data);
}

export async function getMWModules(): Promise<{ data: MWModule[]; count: number }> {
  const response = await axios.get('v2/mw/modules');
  const valid = validate(getMWModulesSchema, response.data.data);
  return { data: valid, count: response.data.count };
}

export async function getMWApplications(): Promise<{ data: MWApplication[]; count: number }> {
  const response = await axios.get('v2/mw/applications');
  const valid = validate(getMWApplicationsSchema, response.data.data);
  return { data: valid, count: response.data.count };
}

export async function getInstallation(): Promise<ModuleInstallation[]> {
  const response = await axios.get('v2/mw/get-installation');
  const valid = validate(getInstallationSchema, response.data.data);
  return valid;
}

export async function UpdateMWModuleCollection(modules: MWModule[]) {
  const response = await axios.post('v2/mw/modules', modules);
  if (response.status === 201) return true;
  return false;
}

export async function UpdateMWApplicationCollection(apps: MWApplication[]) {
  const response = await axios.post('v2/mw/applications', apps);
  if (response.status === 201) return true;
  else return false;
}

export async function getMWUserTypes(): Promise<MWUserType[]> {
  const response = await axios.get('v2/mw/user-types');
  return validate(getMWUserTypesSchema, response.data.data);
}

export async function updateInstallation(
  moduleInstallations: ModuleInstallation[]
): Promise<boolean> {
  const response = await axios.post('v2/mw/update-installation', moduleInstallations);
  if (response.status === 201) return true;
  else return false;
}

export async function getDataTypes(): Promise<DataType[]> {
  const response = await axios.get('v2/mw/data-types');
  return validate(getDataTypesSchema, response.data);
}

export async function updateParams(items: ParamValue[]) {
  const response = await axios.post('/v2/mw/params', items);
  if (response.status === 201) return true;
  return false;
}

export async function getMWRouteTypes(): Promise<MWRouteTypes[]> {
  const response = await axios.get('v2/mw/route-types');
  return validate(getMWRouteTypesSchema, response.data);
}

export async function getMWCountries(): Promise<MWCountry[]> {
  const response = await axios.get('v2/mw/mwCountries');
  return validate(getMWCountriesSchema, response.data.data);
}
